import * as React from 'react'

import { Hero } from './sections/Hero'
import { Logos } from './sections/Logos'
import { Stickers } from './sections/Stickers'
import { BestPractices } from './sections/BestPractices'

/**
 * Logo & Stickers page main content — Ulule's downloadable brand kit (logos, campaign stickers,
 * usage guidelines).
 *
 * Both server-rendered (prerender) and hydrated on the client, so it must stay pure: no
 * `window`/`document`/`localStorage`/`matchMedia` reads during render and no per-request values.
 * Interactive bits (each logo card's light/dark toggle) put their browser work in event handlers and
 * render a deterministic initial state so hydration matches the SSR HTML. The site header/footer are
 * NOT part of this tree — they are mounted separately (see entry-client).
 */
export function App(): React.ReactElement {
  return (
    <main>
      <Hero />
      <Logos />
      <Stickers />
      <BestPractices />
    </main>
  )
}
